// extracted by mini-css-extract-plugin
export var marginAutoCenter = "utilities-module--marginAutoCenter--ddWGP";